/** Exam Module (My Exam + Exam Management) — Vietnamese. Port of erp includes/language/vi/exam.php. */
export const examModule: Record<string, string> = {
  // Status badges (shared across My Exam / admin dashboard / grading)
  'exam.status.draft': 'Bản nháp',
  'exam.status.active': 'Đang mở',
  'exam.status.closed': 'Đã đóng',
  'exam.status.in_progress': 'Đang làm',
  'exam.status.submitted': 'Đã nộp',
  'exam.status.graded': 'Đã chấm',
  'exam.status.partially_graded': 'Đang chấm',

  // My Exam
  'examMy.tabAvailable': 'Khả dụng',
  'examMy.tabInProgress': 'Đang làm',
  'examMy.tabDone': 'Đã nộp',
  'examMy.noTests': 'Chưa có bài thi nào',
  'examMy.colTitle': 'Tiêu đề',
  'examMy.colDuration': 'Thời gian (phút)',
  'examMy.colScheduledEnd': 'Đóng lúc',
  'examMy.colStatus': 'Trạng thái',
  'examMy.start': 'Bắt đầu làm bài',
  'examMy.continue': 'Tiếp tục bài đang làm',
  'examMy.viewDetail': 'Xem chi tiết',

  // Take flow
  'examTake.loading': 'Đang tải bài thi…',
  'examTake.questionOfTotal': 'Câu {n}/{m}',
  'examTake.flagReview': 'Đánh dấu xem lại',
  'examTake.unflag': 'Bỏ đánh dấu',
  'examTake.filterFlagged': 'Chỉ câu đã đánh dấu',
  'examTake.prev': 'Câu trước',
  'examTake.next': 'Câu tiếp',
  'examTake.submit': 'Hoàn thành',
  'examTake.submitConfirm': 'Bạn chắc chắn muốn nộp bài?',
  'examTake.savedOffline': 'Mất kết nối — thử lại',
  'examTake.essayPlaceholder': 'Nhập câu trả lời…',

  // Result
  'examResult.waitingGrade': 'Chờ admin chấm — admin chưa công khai kết quả.',
  'examResult.totalScore': 'Tổng điểm',
  'examResult.autoScore': 'Điểm trắc nghiệm',
  'examResult.essayScore': 'Điểm tự luận',
  'examResult.gradersProgress': 'Đã chấm {n}/{m} admin',
  'examResult.yourAnswer': 'Câu trả lời của bạn',
  'examResult.correct': 'Đúng',
  'examResult.wrong': 'Sai',
  'examResult.notAnswered': '(không trả lời)',
  'examResult.printPdf': 'Tải PDF',
  'examResult.backToMyTests': 'Bài thi của tôi',
  'examResult.missingTestId': 'Thiếu mã bài thi',

  // Admin: tests dashboard
  'examAdmin.filterAll': 'Tất cả',
  'examAdmin.searchPlaceholder': 'Tìm kiếm…',
  'examAdmin.colTitle': 'Tiêu đề',
  'examAdmin.colDepartments': 'Bộ phận tham gia',
  'examAdmin.colQuestionCount': 'Số câu',
  'examAdmin.colDuration': 'Thời gian (phút)',
  'examAdmin.colStatus': 'Trạng thái',
  'examAdmin.colAttempts': 'Lượt làm',
  'examAdmin.actionEdit': 'Sửa',
  'examAdmin.actionGrade': 'Chấm tự luận',
  'examAdmin.actionResults': 'Kết quả',
  'examAdmin.actionActivate': 'Kích hoạt',
  'examAdmin.actionClose': 'Đóng',
  'examAdmin.actionDelete': 'Xoá',
  'examAdmin.deleteConfirm': 'Xoá bài thi {id}?',
  'examAdmin.deleteInUse': 'Không thể xoá: bài thi đã có người làm.',
  'examAdmin.statusChangeConfirm': 'Đổi trạng thái sang {s}?',
  'examAdmin.createBtn': '+ Tạo bài thi',
  'examAdmin.noTests': 'Chưa có bài thi nào',

  // Admin: test builder
  'examBuilder.tabBasic': '1. Thông tin cơ bản',
  'examBuilder.tabQuestions': '2. Câu hỏi',
  'examBuilder.tabSchedule': '3. Lịch',
  'examBuilder.tabGrading': '4. Chấm điểm',
  'examBuilder.fieldTitle': 'Tiêu đề',
  'examBuilder.fieldDescription': 'Mô tả',
  'examBuilder.fieldDepartments': 'Bộ phận tham gia',
  'examBuilder.fieldDuration': 'Thời gian (phút)',
  'examBuilder.fieldStatus': 'Trạng thái',
  'examBuilder.lockNotice': 'Bài thi đang active và đã có người làm. Chỉ chỉnh sửa được mô tả và "công khai kết quả".',
  'examBuilder.pickedCount': 'đã chọn',
  'examBuilder.searchQuestions': 'Tìm câu hỏi…',
  'examBuilder.selectAll': 'Chọn tất cả',
  'examBuilder.deselectAll': 'Bỏ chọn tất cả',
  'examBuilder.fieldScheduledStart': 'Mở lúc',
  'examBuilder.fieldScheduledEnd': 'Đóng lúc',
  'examBuilder.fieldEssayMethod': 'Cách tính điểm tự luận',
  'examBuilder.essayMethodSum': 'Tổng điểm các admin',
  'examBuilder.essayMethodAverage': 'Trung bình các admin',
  'examBuilder.fieldMinGraders': 'Số admin tối thiểu',
  'examBuilder.fieldPublishResults': 'Cho phép xem kết quả',
  'examBuilder.shuffleQuestions': 'Xáo thứ tự câu hỏi',
  'examBuilder.shuffleOptions': 'Xáo thứ tự đáp án',
  'examBuilder.save': 'Lưu',
  'examBuilder.titleRequired': 'Tiêu đề là bắt buộc',
  'examBuilder.needDept': 'Chọn ít nhất 1 bộ phận',
  'examBuilder.needQuestion': 'Chọn ít nhất 1 câu hỏi',

  // Admin: question bank
  'examBank.tabBank': 'Ngân hàng',
  'examBank.tabImport': 'Nhập CSV',
  'examBank.filterAll': 'Tất cả',
  'examBank.mc': 'Trắc nghiệm',
  'examBank.essay': 'Tự luận',
  'examBank.createBtn': '+ Tạo câu hỏi',
  'examBank.colType': 'Loại',
  'examBank.colText': 'Nội dung',
  'examBank.colScore': 'Điểm',
  'examBank.colDept': 'Tag bộ phận',
  'examBank.colCategory': 'Chủ đề',
  'examBank.deleteConfirm': 'Xoá câu hỏi này?',
  'examBank.deleteInUse': 'Không thể xoá: câu hỏi đang được dùng trong 1 bài thi.',
  'examBank.modalCreateTitle': 'Tạo câu hỏi',
  'examBank.modalEditTitle': 'Sửa câu hỏi',
  'examBank.fieldType': 'Loại câu hỏi',
  'examBank.fieldText': 'Nội dung câu hỏi',
  'examBank.fieldOptions': 'Đáp án (✓ = đúng)',
  'examBank.fieldScore': 'Điểm',
  'examBank.fieldDept': 'Tag bộ phận',
  'examBank.fieldCategory': 'Chủ đề',
  'examBank.addOption': '+ Đáp án',
  'examBank.optionPlaceholder': 'Nội dung đáp án',
  'examBank.needTwoOptions': 'Cần ít nhất 2 đáp án',
  'examBank.needCorrect': 'Đánh dấu ít nhất 1 đáp án đúng',
  'examBank.noData': 'Không có dữ liệu',

  // Admin: CSV import
  'examImport.templateDownload': 'Tải template CSV',
  'examImport.preview': 'Xem trước',
  'examImport.confirmImport': 'Xác nhận import',
  'examImport.cancel': 'Huỷ',
  'examImport.columnsHint': 'Cột: type, category, department_tag, text, option_a..d, correct, score. type = multiple_choice | essay. Tối đa 2MB / 1000 dòng.',
  'examImport.rowsValid': '{ok}/{total} dòng hợp lệ',
  'examImport.inserted': 'đã thêm',
  'examImport.invalidSkipped': 'dòng lỗi bị bỏ qua',
  'examImport.failed': 'thất bại',
  'examImport.colStatus': 'Trạng thái',
  'examImport.colErrors': 'Lỗi',
  'examImport.ok': 'Đạt',
  'examImport.err': 'Lỗi',

  // Admin: grade essay
  'examGrade.pickTest': 'Chọn bài thi',
  'examGrade.open': 'Mở',
  'examGrade.backToDashboard': 'Quản lý bài thi',
  'examGrade.backToAttempts': 'Danh sách bài làm',
  'examGrade.minGraders': 'Số admin tối thiểu',
  'examGrade.method': 'Cách tính',
  'examGrade.publishResults': 'Công khai kết quả',
  'examGrade.unpublishResults': 'Ẩn kết quả',
  'examGrade.resultsPublic': 'Kết quả đang công khai',
  'examGrade.resultsHidden': 'Kết quả đang ẩn',
  'examGrade.colEmail': 'Email',
  'examGrade.colDept': 'Bộ phận',
  'examGrade.colStatus': 'Trạng thái',
  'examGrade.colAuto': 'Trắc nghiệm',
  'examGrade.colEssay': 'Tự luận',
  'examGrade.colTotal': 'Tổng',
  'examGrade.colGradedByMe': 'Bạn đã chấm',
  'examGrade.gradeBtn': 'Chấm',
  'examGrade.maxScore': 'Điểm tối đa',
  'examGrade.save': 'Lưu',
  'examGrade.savedGraders': 'Đã lưu. Số admin đã chấm: {n}/{m}',
  'examGrade.noAttempts': 'Chưa có bài làm',

  // Admin: results + leaderboard
  'examResults.pickTest': 'Chọn bài thi',
  'examResults.leaderboard': 'Bảng xếp hạng',
  'examResults.export': 'Xuất CSV',
  'examResults.questionStats': 'Thống kê câu hỏi (% đúng)',
  'examResults.colRank': '#',
  'examResults.colEmail': 'Email',
  'examResults.colDept': 'Bộ phận',
  'examResults.colStatus': 'Trạng thái',
  'examResults.colAuto': 'Trắc nghiệm',
  'examResults.colEssay': 'Tự luận',
  'examResults.colTotal': 'Tổng',
  'examResults.colSubmitted': 'Đã nộp',
  'examResults.colTabEvents': 'Số lần rời tab',
  'examResults.colName': 'Họ tên',
  'examResults.colPassed': 'Đạt',
  'examResults.passedYes': 'Đạt',
  'examResults.passedNo': 'Chưa đạt',
  'examResults.passedSummary': '{n}/{total} đạt từ {score} điểm',
  'examResults.noAttempts': 'Chưa có bài làm',

  // Department tag friendly labels (only ambiguous tags overridden; rest render raw)
  'examDept.all': 'Tất cả (mọi bộ phận)',
  'examDept.test': 'QA',
  'examBuilder.filterCategory': 'Tất cả chủ đề',

  // Take flow — extra
  'examTake.autoSubmitted': 'Hết giờ — bài đã tự động nộp.',
  // Common dept fallback
  'examCommon.deptUnassigned': '—',
};
